import React from 'react';

interface LoadingStateProps {
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-t1blue"></div>
      <p className="mt-2 text-sm text-gray-500">{message}</p>
    </div>
  );
};

export default LoadingState; 